// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardCompletedStatusCard_root__Ewg9F","text":"PlasmicDashboardCompletedStatusCard_text__mwZz9"};